module.exports = __webpack_public_path__ + "static/media/camera.3d9e980f.png";